module.exports = __webpack_public_path__ + "img/presentations.3a546450.svg";